const TOGGLERS = 'data-toggler';
const TOGGLERS_TRIGGER = 'data-toggler-trigger'
const TOGGLERS_CONTENT = 'data-toggler-content' // later use ?

function init() {
  const $togglers = document.querySelectorAll(`[${TOGGLERS_TRIGGER}]`);
  const locationHash = window.location.hash;
  if (!$togglers) return
  initTogglers($togglers);
  if (locationHash) {
    autoToggleContent(locationHash.substring(1));
  }
}

function initTogglers($togglers) {
  $togglers.forEach($toggler => {
    const togglerId = $toggler.getAttribute(TOGGLERS_TRIGGER);
    const $togglerContainer = document.querySelector(`[${TOGGLERS}=${togglerId}]`)

    // abort if no toggler container
    if (!$togglerContainer) return;

    // hide on load
    $togglerContainer.classList.add('toggler-is-hidden')

    // add click event
    $toggler.addEventListener('click', function (event) {
      event.preventDefault();
      $toggler.classList.toggle('toggled-is-visible')
      $togglerContainer.classList.toggle('toggler-is-hidden')
    });
  });
}

/**
 * Hash detected in URL, check if toggler exists, then display it
 */
function autoToggleContent(id) {
  const $togglerContainer = document.getElementById(id);
  if (!$togglerContainer) return
  $togglerContainer.classList.toggle('toggler-is-hidden')
}

export default { init }









